import { QuoteDataGridType, UnderwriterHomePageTabs } from '@pages/Quotes/QuotesTable/DataGrid.constants';
import { QuoteColumnField } from '@pages/Quotes/QuotesTable/QuoteColumnField.enum';

export const getDefaultHiddenColumns = (viewType: QuoteDataGridType) => {
  if (UnderwriterHomePageTabs.includes(viewType)) {
    // note false = it will show by default
    // true = hidden
    return {
      [QuoteColumnField.UnreadMessageNotification]: false,
      [QuoteColumnField.FlaggedAsImportant]: true,
      [QuoteColumnField.QuoteId]: true,
      [QuoteColumnField.QuoteNumber]: false,
      [QuoteColumnField.AccountName]: false,
      [QuoteColumnField.Address]: true,
      [QuoteColumnField.StatusChangeDate]: true,
      [QuoteColumnField.EffectiveDate]: false,
      [QuoteColumnField.ProductOffering]: false,
      [QuoteColumnField.ProductLabel]: true,
      [QuoteColumnField.BusinessClass]: false,
      [QuoteColumnField.QuoteType]: [
        QuoteDataGridType.UWHomePageAllTransaction,
        QuoteDataGridType.UWHomePageRecentlyViewed,
      ].includes(viewType)
        ? false
        : true,
      [QuoteColumnField.Status]: false,
      [QuoteColumnField.ModifiedDate]: false,
      [QuoteColumnField.CreatedAt]: true,
      [QuoteColumnField.CreatedByUser]: true,
      [QuoteColumnField.UnderwritingStatus]: false,
      [QuoteColumnField.TotalPremium]: false,
      [QuoteColumnField.Brokerage]: false,
      [QuoteColumnField.Producer]: false,
      [QuoteColumnField.Underwriter]: false,
      [QuoteColumnField.ReasonForReferral]: true,
      [QuoteColumnField.QuoteOrigin]: false,
      [QuoteColumnField.WritingCompany]: true,
    } as Record<string, boolean>;
  }
  return {
    [QuoteColumnField.QuoteNumber]: false,
    [QuoteColumnField.FlaggedAsImportant]: true,
    [QuoteColumnField.Favorite]: false,
    [QuoteColumnField.QuoteId]: true,
    [QuoteColumnField.Brokerage]: true,
    [QuoteColumnField.Cancel]: true,
    [QuoteColumnField.ProductLabel]: true,
    [QuoteColumnField.BusinessClass]: true,
    [QuoteColumnField.CreatedByUser]: true,
    [QuoteColumnField.TotalPremium]: true,
    [QuoteColumnField.EffectiveDate]: true,
    [QuoteColumnField.Underwriter]: true,
    [QuoteColumnField.UnderwritingStatus]: true,
    [QuoteColumnField.StatusChangeDate]: false,
    [QuoteColumnField.ReasonForReferral]: true,
    [QuoteColumnField.QuoteType]: true,
    [QuoteColumnField.ModifiedDate]: true,
    [QuoteColumnField.AccountName]: false,
    [QuoteColumnField.Address]: false,
    [QuoteColumnField.ProductOffering]: false,
    [QuoteColumnField.Status]: false,
    [QuoteColumnField.Producer]: false,
    [QuoteColumnField.WritingCompany]: true,
  } as Record<string, boolean>;
};
